import { ExcelService } from './../../services/excel.service';
import { CollegeDetailService } from './../../services/college-detail.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { MenuService } from './../../services/menu.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { NotificationService } from './../../services/notification.service';
import { WebService } from './../../services/web.service';
import { Component, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CollegeSearchInput } from '../../models';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-student-college-search',
  templateUrl: './student-college-search.component.html',
  styleUrls: ['./student-college-search.component.scss']
})
export class StudentCollegeSearchComponent implements OnInit, OnDestroy {

  @Input() currentStudentProfileId: number;
  orderByOptions = ['MyFit Score', 'A - Z', 'Z - A'];
  loading = false;
  dataLoader = false;
  showFilterPanel = true;
  handleScroll = false;
  text: any;
  deadline = false;
  currentPageId;
  @Input() orderType: string;
  @ViewChild('savePopup') savePopup;
  myFitValue: any;

  labelsHead: any = {
    degree: { label: 'Degree', data: [] },
    religious: { label: 'Religious', data: [] },
    location: { label: 'Location', data: [] },
    studentPopulation: { label: 'Student Population', data: [] },
    state: { label: 'State', data: [] },
    schoolType: { label: 'School Type', data: [] },
    classSize: { label: 'Class Size', data: [] },
    citySize: { label: 'City Size', data: [] },
    careerCluster: { label: 'Career Cluster', data: [] },
    difficulty: { label: 'Admission Difficulty', data: [] },
    strandardizedTestingpolicy: { label: 'Strandardized Testing policy', data: [] },
    supportServices: { label: 'Special Considerations', data: [] },
    sports: { label: 'Sports', data: [] },
    clubSports: { label: 'Club Sports', data: [] },
    housingOptions: { label: 'Housing Options', data: [] },
    rotc: { label: 'ROTC', data: [] },
    gender: { label: 'Gender', data: [] },
    collegeType: { label: 'College Type', data: [] },
    career: { label: 'Careers', data: [] },
    majors: { label: 'Major', data: [] }
  };
  loader = false;
  midState: any;
  careerList: any[] = [];
  careerListFullData: any[] = [];
  majorList: any[] = [];
  majorListFullData = [];
  studentState: string;
  collegeSearchInput: CollegeSearchInput = new CollegeSearchInput();
  labels = {};
  partnerUserNToken = { userId: null, partnerId: null };
  studentInfo = { studentUserId: null, studentProfileId: null };

  // api response
  showCollege = true;
  collegeExcelData = [];
  searchResponse: any[] = [];
  collegeListDropdown: any[] = [];
  savedCollegeSearchCriteria = [];
  count = 0;
  autoSuggestCollegeName;
  selectedCareer = [];
  selectedMajor = [];
  selectedReligious = [];
  careerField = null;
  religiousfield = null;
  majorField = null;
  criteriaName;
  filterShow = true;
  loadName: any;
  searchSportsFilter = false;
  genderIdValue: any;
  labelsData = [];
  labelSports: any;
  searchSports: any;
  manualSelectedMajor = [];
  searchFlag = true;
  currentStudentID: string;
  scrollResults = false;
  removeScrollListener: Function;
  subs: Subscription[] = [];
  localData;
  myfitCalulation = false;
  timeRemaining: any;

  constructor(
    private webService: WebService,
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonDataSharedService: CommonDataSharedService,
    public _router: Router,
    private _routes: ActivatedRoute,
    private builder: FormBuilder,
    private _sanitizer: DomSanitizer,
    private _menuService: MenuService,
    private _commonAuthenticationService: CommonAuthenticationService,
    private _collegeDetailService: CollegeDetailService,
    private excelService: ExcelService,
    private renderer: Renderer2
  ) {
    this.removeScrollListener = this.renderer.listen('window', 'scroll', () => {
      this.onWindowScroll();
    });
  }

  onWindowScroll() {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 10) {
      if (this.handleScroll && !this.loading && this.searchResponse && this.count > this.searchResponse.length) {
        if (this.count > this.collegeSearchInput.pageSize) {
          this.collegeSearchInput.page += 1;
          localStorage.setItem('collegeSearchLastPage', this.collegeSearchInput.page.toString());
          this.dataLoader = true;
           this.searchCollege(true);
        }
      }
    }
  }

  ngOnInit() {
    this.autoSuggestCollegeName = this.builder.group({
      continent: '',
    });
    this.localData = JSON.parse(localStorage.getItem('collegeData'));
    if (this.localData) {
      this.collegeListDropdown = this.localData.map(data => data);
    }
    this.currentStudentID = JSON.parse(localStorage.getItem('studentLocalId'));
    const localStorageData = this._commonAuthenticationService.getLoginData();
    this.genderIdValue = JSON.parse(localStorage.getItem('genderIdValue'));
    this.studentInfo.studentUserId = localStorageData.userId;
    this.studentInfo.studentProfileId = this.currentStudentProfileId || localStorageData.profileId;
    this.partnerUserNToken.userId = localStorageData.userId;
    this.partnerUserNToken.partnerId = localStorageData.partnerId;
    this.studentState = localStorageData.stateClassID;
    this.deadline = !(localStorageData.role === 'Student' || localStorage.role === 'Parent');
    this.getPageData();
    let classTypeNames = [];

    Object.keys(this.labelsHead).forEach((e) => {
      classTypeNames.push(this.labelsHead[e].label);
    });
    this.orderType = 'name';
    this.apiCall('admin/valuesbylist', { classTypeNames: classTypeNames }, (data: any) => {
      Object.keys(this.labelsHead).forEach((e) => {
        const child = data.item.filter(x => x.text === this.labelsHead[e].label)[0];
        if (!child) {
          return;
        }
        this.labelsHead[e].data = child.item;
        this.labelsHead[e].id = child.id;
      });
      classTypeNames = [];
      this.labelsHead.location.data.forEach((e) => {
        classTypeNames.push(e.text + ' States');
      });
      this.apiCall('admin/valuesbylist', { classTypeNames: classTypeNames }, (dataChild) => {
        this.midState = {};
        if (dataChild.item instanceof Array) {
          dataChild.item.forEach((el) => {
            const itemId = [];
            if (el.item instanceof Array) {
              el.item.forEach((elChild) => {
                itemId.push(elChild.value);
              });
            }
            this.midState[el.text.toLowerCase()] = itemId;
          });
        }
        this.collegeSearchJsonData();
      }, 'Error While Fetching CareerList',
        () => {
        });
    }, 'Error While Fetching CareerList');

    this.getSaveSearchCriteria();
    this.subs.push(
      this._commonDataSharedService.closeCollegeDetail.subscribe((data: any) => {
        this.showCollege = true;
      }),

      this._commonDataSharedService.collegesFilter.subscribe((data: any) => {
        this.collegeSearchInput.sortBy = data;
        this.loading = true;
        this.searchCollege();
      }),

      this._commonDataSharedService.dynamicStudentDetailData
        .subscribe(
          (data: any) => {
            this.studentInfo.studentUserId = data.studentUserId;
            this.studentInfo.studentProfileId = this.currentStudentProfileId || data.profileId;
          }),
    );
    localStorage.setItem('collegeSearchPath', this._routes.snapshot.url[0].path)

    this.collegeSearchInput.sortBy = JSON.parse(localStorage.getItem('loginUserData')).module.toLowerCase() === 'coach' && localStorage.getItem('collegeSearchPath') === 'collegeSearch' && localStorage.getItem('collegeSearchPath') !== 'coachStudentDetail' ? 'A-Z' : 'MyFit Score';

    this.myFitValue = setInterval(() => {
      if (this.myfitCalulation && this.timeRemaining) {
        this.searchCollege();
      }

    }, 10000);


  }

  searchValueFormatter(data: any): string {
    return data.name;
  }

  searchListFormatter(data: any): string {
    return data.name;
  }

  autocompleListFormatter = (data: any) => {
    const html = `<span>${data.name}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  };

  regionSelect(event, item) {
    const ch = event.target.checked;
    const it = this.midState[item.text.toLowerCase() + ' states'];

    if (it) {
      this.labelsHead.state.data.forEach((e) => {
        if (it.indexOf('' + e.id) >= 0) {
          e.checked = ch;
        }
      });
    }

    this.filterData();
  }

  getCollegeNameData() {
    this._collegeDetailService.getCollegeList({}).subscribe((data: any) => {
      data.item.forEach((college) => {
        this.collegeListDropdown.push(college.name)
      })
    })
  }

  disabledCheck(event, labelsObject, currenctlabelObject) {
    const disabled = event.target.checked;
    if (currenctlabelObject.text === 'No Preference') {
      labelsObject.data.forEach((element) => {
        element.checked = false;
        element.disabled = disabled;
      });
      currenctlabelObject.checked = disabled;
      currenctlabelObject.disabled = false;
    }

    this.filterData();
  }

  onSelectCareer(event: any, array: Array<any>, category: string, majorSelected: boolean) {
    if (array.indexOf(event) === -1) {
      array.push(event);
      if (category === 'major') {
        if (majorSelected) {
          this.manualSelectedMajor.push({ id: event.id, text: event.text });
        }
        if (this.collegeSearchInput.majorsCareers.majorCode.indexOf(event.id) === -1) {

          this.collegeSearchInput.majorsCareers.majorCode.push(event.id)
        }

      } else {
        this.manualSelectedMajor = [];
        this.collegeSearchInput.majorsCareers.careers.push(event.id)
        this.getMajorData(this.collegeSearchInput);
      }
    }

    setTimeout(() => {
      this.careerField = null;
      this.majorField = null;
    }, 100)

  }

  onSelectReligious(event: any, array: any[]) {
    if (array.indexOf(event) === -1) {
      this.collegeSearchInput.social.religious.push(event.id);
      this.selectedReligious.push(event);
    }

    setTimeout(() => {
      this.religiousfield = null;
    }, 100)
  }

  getMajorData(object: any) {
    this.selectedMajor = [];
    if (this.manualSelectedMajor.length > 0) {
      for (let i = 0; i < this.manualSelectedMajor.length; i++) {
        this.selectedMajor.push(this.manualSelectedMajor[i])
      }
    }

    const json = {
      careerids: object.majorsCareers.careers,
    };

    this._collegeDetailService.getMajorCareers(json)
      .subscribe(
        dataList => {
          this.collegeSearchInput.majorsCareers.majorCode = [];

          for (let i = 0; i < dataList.length; i++) {
            this.onSelectCareer(dataList[i], this.selectedMajor, 'major', false);
          }
        },
        () => {
          this.notificationService.show('error', 'Error While Fetching MajorList');
        });
  }

  removeReligious(arrayGroup: any[], element) {
    const index = arrayGroup.indexOf(element);
    arrayGroup.splice(index, 1);

    this.collegeSearchInput.social.religious.splice(this.collegeSearchInput.social.religious.indexOf(element), 1);
  }

  removeCareer(arrayGroup: any[], index: number, category: string) {
    arrayGroup.splice(index, 1);
    if (category === 'major') {
      this.collegeSearchInput.majorsCareers.majorCode.splice(index, 1);
      this.manualSelectedMajor.splice(index, 1);
    } else {
      this.collegeSearchInput.majorsCareers.careers.splice(this.collegeSearchInput.majorsCareers.careers.indexOf(index), 1);
      const arr = [];

      for (let i = 0; i < arrayGroup.length; i++) {
        arr.push(arrayGroup[i].id);
      }

      this.collegeSearchInput.majorsCareers.careers = arr;
      this.getMajorData(this.collegeSearchInput);
    }
  }

  addCollegeName() {
    if (this.autoSuggestCollegeName && this.autoSuggestCollegeName.value && this.autoSuggestCollegeName.value.continent && !this.autoSuggestCollegeName.value.scid) {
      this.localData.filter(x => {
        if (x.name === this.autoSuggestCollegeName.value.continent) {
          this.autoSuggestCollegeName.value.continent = {
            name: x.name,
            scid: x.scid
          }
        }
      })
    }

    if (this.autoSuggestCollegeName.value && this.autoSuggestCollegeName.value.continent && this.autoSuggestCollegeName.value.continent.scid) {
      this._collegeDetailService.setCollegePin(this.autoSuggestCollegeName.value.continent.scid, this.studentInfo.studentUserId)
        .subscribe(
          (data: any) => {
            this.notificationService.show('success', 'pin college successfully');

            if (this.searchResponse) {
              const objectData = this.searchResponse.filter(x => x.id === this.autoSuggestCollegeName.value.continent.scid);
              if (objectData.length > 0) {
                objectData[0].pinned = true;
              }
            }

            this._commonDataSharedService.addCollege.next();

          }, () => this.notificationService.show('error', 'Error while pinning college')
        );
    }
  }

  showCollegeDetail() {

    // this.autoSuggestCollegeName.value.continent = this.autoSuggestCollegeName.value.continent.name ? this.autoSuggestCollegeName.value.continent.name : this.autoSuggestCollegeName.value.continent;
    this.localData.filter(x => {
      if (x.scid === this.autoSuggestCollegeName.value.continent.scid) {
        this.autoSuggestCollegeName.value.continent = {
          name: x.name,
          scid: x.scid
        }
      }
    });
    if (this.autoSuggestCollegeName.value && this.autoSuggestCollegeName.value.continent.name && this.autoSuggestCollegeName.value.continent.scid) {
      this.viewCollege(this.autoSuggestCollegeName.value.continent.scid);
    } else if (this.autoSuggestCollegeName.value.continent.name && !this.autoSuggestCollegeName.value.continent.scid) {
      this.localData.forEach((college) => {
        if (this.autoSuggestCollegeName.value.continent.name === college) {
          this.viewCollege(college.scid);
        }
      });

    }

    const addCollegeTabIndex = 5;
    localStorage.setItem('selectedIndex', addCollegeTabIndex.toString())
  }

  getSaveSearchCriteria() {
    this._collegeDetailService.getProfileCollegeSearch({ profileId: this.studentInfo.studentProfileId })
      .subscribe(
        (data: any) => {
          this.savedCollegeSearchCriteria = data.item
        },
        error =>
          this.notificationService.show('error', error || 'Error While calling api')
      )
  }

  searchCriteriaPrepare(forSaving = false) {
    const criteria = Object.assign({}, this.collegeSearchInput, forSaving);
    this.setInput('degree', criteria.college, 'degreeTypeClassIds', forSaving);
    this.setInput('location', criteria.college, 'regionClassIds', forSaving);
    this.setInput('studentPopulation', criteria.college, 'schoolPopulationClassIds', forSaving);
    this.setInput('state', criteria.college, 'regionStateClassIds', forSaving);
    this.setInput('schoolType', criteria.college, 'schoolTypeClassIds', forSaving);
    this.setInput('classSize', criteria.college, 'classSizeClassIds', forSaving);
    this.setInput('citySize', criteria.college, 'citySizeClassIds', forSaving);
    this.setInput('difficulty', criteria.academics, 'difficultyClassIds', forSaving);
    this.setInput('supportServices', criteria.supportFinancial, 'supportFinancialClassIds', forSaving);
    this.setInput('clubSports', criteria.social, 'clubSportsClassIds', forSaving);
    this.setInput('collegeType', criteria.college, 'collegeTypeClassIds', forSaving);

    criteria.supportFinancial.studentStateId = this.studentState;
    criteria.social.genderClassId = this.genderIdValue;
    criteria.social.collgeSportsClassIds = [];
    this.labelsHead.sports.data.forEach((e) => {
      if (e && (e.I || e.II || e.III || e.IV)) {
        criteria.social.collgeSportsClassIds.push({
          sportsClassId: e.id,
          gender: e.gender || 0,
          I: e.I || false,
          II: e.II || false,
          III: e.III || false,
          IV: e.IV || false
        });
      }
    });

    this.labelsHead.housingOptions.data.map((e) => {
      if (e && e.checked) {
        switch (e.text) {
          case 'Coed':
            criteria.social.housingCoed = true;
            break;
          case 'Men Only':
            criteria.social.housingMen = true;
            break;
          case 'Special Housing for Individuals':
            criteria.social.housingDisabled = true;
            break;
          case 'Special Housing for Individuals with Disabilities':
            criteria.social.housingDisabled = true;
            break;
          case 'Women Only':
            criteria.social.housingWomen = true;
            break;
          default:
            // code...
            break;
        }
      }
    });

    this.labelsHead.rotc.data.map((e) => {
      if (e && e.checked) {
        switch (e.text) {
          case 'Air Force':
            criteria.social.airROTC = true;
            break;
          case 'Army':
            criteria.social.armyROTC = true;
            break;
          case 'Navy':
            criteria.social.navyROTC = true;
            break;
          case 'General':
            criteria.social.generalROTC = true;
            break;
          default:
            // code...
            break;
        }
      }
    });

    return criteria;
  }

  setInput(key, Objects, keyPush, forSaving) {
    const input = this.labelsHead[key];
    if (input && input.data instanceof Array) {
      Objects[keyPush] = [];
      input.data.forEach((e) => {
        if (e && e.checked) {
          if (e.text === 'No Preference' && !forSaving) {
            Objects[keyPush] = [0];
          } else {
            Objects[keyPush].push(e.id);
          }
        }
      });
    }
  }

  searchCollege(append = false) {
    if (localStorage.getItem('routeArray') && JSON.parse(localStorage.getItem('routeArray')).includes('collegeSearch')) {
      this.loading = true;
    }
    if (this.collegeSearchInput.college.applicationDueDateInFuture === null) {
      this.collegeSearchInput.college.applicationDueDateInFuture = false;
    }

    const searchData = this.searchCriteriaPrepare();
    searchData.academics.ebrw = searchData.academics.ebrw || null;
    searchData.academics.actComp = searchData.academics.actComp || null;
    searchData.academics.actNotReported = !!searchData.academics.actNotReported;
    searchData.academics.satNotReported = !!searchData.academics.satNotReported
    const json = Object.assign(searchData, this.partnerUserNToken) as any;
    json.userId = localStorage.getItem('collegeSearchPath') === 'collegeSearch' ? this._commonAuthenticationService.getLoginData().userId : this.currentStudentID;
    json.pageSize = 50;

    this._commonRequestResponseService.postWithHeader('college/search', json).subscribe(
      (data: any) => {
        this.loading = false;
        if (this.searchFlag && !append) {
          localStorage.setItem('searchResult', JSON.stringify(json));
        }

        if (data.items.length !== 0 && data.items instanceof Array) {
          this.scrollResults = true;
          if (append) {
            data.items.forEach(e => this.searchResponse.push(e));
          } else {
            this.searchResponse = data.items;
            // Scroll to the top of the page, since the window size will have changed.
            const getPosition = function (element) {
              let xPosition = 0;
              let yPosition = 0;
              while (element) {
                xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
                yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
                element = element.offsetParent;
              }
              return { x: xPosition, y: yPosition };
            };
            document.body.scrollTop = document.documentElement.scrollTop = getPosition(document.getElementById('ns-college-search-bar')).y;
          }
          this.showFilterPanel = false;
          this.handleScroll = true;
          this.filterShow = false;
          this.count = data.total;
          const collegeSearchLastPage = JSON.parse(localStorage.getItem('collegeSearchLastPage'));
          if (collegeSearchLastPage && collegeSearchLastPage > this.collegeSearchInput.page) {
            this.collegeSearchInput.page += 1;
            this.searchCollege(true);
          }
        }
        this.loading = false;
        this.dataLoader = false;
        if (!this.handleScroll && !append) {
          this.loading = false;
          this.dataLoader = false;
          this.notificationService.show('error', 'No Data Found');
        }

        this.myfitCalulation = data.myFitCalculating;
        this.timeRemaining = data.timeRemaining;
        if (!this.myfitCalulation || !this.timeRemaining) {
          clearInterval(this.myFitValue);
        }

        // // Hide the search facets.
      },
      () => this.loading = false)

    const addCollegeTabIndex = 5;
    localStorage.setItem('selectedIndex', addCollegeTabIndex.toString())
  }

  exportToExcel() {
    const searchData = this.searchCriteriaPrepare();
    searchData.academics.ebrw = searchData.academics.ebrw || null;
    searchData.academics.actComp = searchData.academics.actComp || null;
    searchData.academics.actNotReported = !!searchData.academics.actNotReported;
    searchData.academics.satNotReported = !!searchData.academics.satNotReported;
    const json = Object.assign(searchData, this.partnerUserNToken) as any;
    json.userId = this.currentStudentID;
    json.pageSize = 5000;
    this.collegeExcelData = [];

    this._collegeDetailService.search(json)
      .subscribe(
        (data: any) => {
          if (data.items) {
            const response = data.items;
            response.forEach((college) => {
              this.collegeExcelData.push({
                collegeName: college.name,
                abbreviation: college.abbreviation,
                city: college.city,
                myFitRank: college.myFitRank,
                state: college.state
              })
            });
          }
          this.excelService.exportAsExcelFile(this.collegeExcelData, 'collegeData');
        })
  }

  reset() {
    clearInterval(this.myFitValue);
    this.filterShow = true;
    this.labelsData = [];
    this.searchSportsFilter = false;
    this.collegeSearchInput = new CollegeSearchInput();
    this.selectedCareer = [];
    this.collegeSearchInput.sortBy = JSON.parse(localStorage.getItem('loginUserData')).module.toLowerCase() === 'coach' && localStorage.getItem('collegeSearchPath') === 'collegeSearch' && localStorage.getItem('collegeSearchPath') !== 'coachStudentDetail' ? 'A-Z' : 'MyFit Score';
    this.selectedMajor = [];
    this.selectedReligious = [];
    localStorage.removeItem('searchResult');
    localStorage.removeItem('collegeSearchLastPage');
    Object.keys(this.labelsHead).forEach((e) => {
      const data = this.labelsHead[e].data;
      if (data instanceof Array) {
        data.forEach((e1) => {
          e1.checked = false;
          e1.disabled = false;
        });
      }
    });

    const sportData = this.labelsHead.sports.data;
    if (sportData instanceof Array) {
      sportData.forEach((e1) => {
        e1.I = false;
        e1.II = false;
        e1.III = false;
        e1.IV = false;
        e1.gender = undefined;
      });
    }
    this.careerList = [];
    this.majorList = [];
    this.careerListFullData.forEach(e => e.checked = false);
    this.majorListFullData.forEach(e => e.checked = false);
    this.handleScroll = false;
    this.showFilterPanel = true;
    this.searchResponse = [];

  }

  saveSearchCriteria(name) {
    this.loading = true;
    if (!name) {
      this.loading = false;
      this.notificationService.show('error', 'Please enter name to save search');
    } else {
      if (this.savedCollegeSearchCriteria instanceof Array && this.savedCollegeSearchCriteria.filter(x => x.name === name).length > 0) {
        this.loading = false;
        this.notificationService.show('error', 'This Name Already Exist');
        return;
      }
      const json = {
        profileId: this.studentInfo.studentProfileId,
        CriteriaJson: this.searchCriteriaPrepare(true),
        name: name
      };

      this._collegeDetailService.profileSaveCollageSearch(json)
        .subscribe(
          () => {
            this.loading = false;
            this.getSaveSearchCriteria();
            this.savePopup.hide();
            this.notificationService.show('success', 'Your search is saved successfully');
            this.reset();
          }, () => {
            this.loading = false;
            this.notificationService.show('error', 'Error While Fetching saveData')
          });
      this.criteriaName = ''
    }
  }

  inputToCriteria(key, Objects, keyPushed) {
    const input = this.labelsHead[key];
    const criteria = Objects[keyPushed];
    if (input && input.data instanceof Array && criteria instanceof Array) {
      input.data.forEach((e) => {
        if (e) {
          e.checked = criteria.indexOf(e.id) >= 0;
        }
      });
    }
  }

  onSelectSearchCriteria() {
    this.reset();
    this.collegeSearchJsonData();
    this.loading = true;
    const model = {
      profileId: this.studentInfo.studentProfileId,
      id: this.loadName
    };

    this.webService.post('College/GetProfileCollageSearch', model).subscribe(
      (data: any) => {
        this.loading = false;
        this.collegeSearchInput = data.item[0].criteriaJson as CollegeSearchInput || new CollegeSearchInput();

        if (this.collegeSearchInput) {
          this.inputToCriteria('degree', this.collegeSearchInput.college, 'degreeTypeClassIds');
          this.inputToCriteria('location', this.collegeSearchInput.college, 'regionClassIds');
          this.inputToCriteria('studentPopulation', this.collegeSearchInput.college, 'schoolPopulationClassIds');
          this.inputToCriteria('state', this.collegeSearchInput.college, 'regionStateClassIds');
          this.inputToCriteria('schoolType', this.collegeSearchInput.college, 'schoolTypeClassIds');
          this.inputToCriteria('classSize', this.collegeSearchInput.college, 'classSizeClassIds');
          this.inputToCriteria('citySize', this.collegeSearchInput.college, 'citySizeClassIds');
          this.inputToCriteria('difficulty', this.collegeSearchInput.academics, 'difficultyClassIds');
          this.inputToCriteria('supportServices', this.collegeSearchInput.supportFinancial, 'supportFinancialClassIds');
          this.inputToCriteria('clubSports', this.collegeSearchInput.social, 'clubSportsClassIds');
          this.inputToCriteria('collegeType', this.collegeSearchInput.college, 'collegeTypeClassIds');
          this.inputToCriteria('careerCluster', this.collegeSearchInput.majorsCareers, 'industry');
          this.inputToCriteria('religious', this.collegeSearchInput.social, 'religious');

          if (this.collegeSearchInput.majorsCareers.careers) {
            for (let j = 0; j < this.collegeSearchInput.majorsCareers.careers.length; j++) {
              this.selectedCareer.push(this.labelsHead.career.data.filter(item => item.id === this.collegeSearchInput.majorsCareers.careers[j])[0])
            }
          }

          if (this.collegeSearchInput.majorsCareers.majorCode) {
            for (let k = 0; k < this.collegeSearchInput.majorsCareers.majorCode.length; k++) {
              this.selectedMajor.push(this.labelsHead.majors.data.filter(item => item.id === this.collegeSearchInput.majorsCareers.majorCode[k])[0])
            }
          }

          if (this.collegeSearchInput.social.religious) {
            for (let k = 0; k < this.collegeSearchInput.social.religious.length; k++) {
              this.selectedReligious.push(this.labelsHead.religious.data.filter(item => item.id === this.collegeSearchInput.social.religious[k])[0])
            }
          }
        }

        Object.keys(this.labelsHead).forEach((e) => {
          const ob = this.labelsHead[e];
          ob.data.forEach((e1) => {
            if (e1.checked && e1.text === 'No Preference') {
              ob.data.forEach((e2) => {
                if (!e2.checked) {
                  e2.disabled = true;
                }
              });
            }
          });

          this.filterData();
        });

        this.labelsHead.sports.data.forEach((e) => {
          if (e) {
            e.I = this.collegeSearchInput.social.collgeSportsClassIds.filter(e1 => e1.sportsClassId === e.id && e1.I).length > 0;
            e.II = this.collegeSearchInput.social.collgeSportsClassIds.filter(e1 => e1.sportsClassId === e.id && e1.II).length > 0;
            e.III = this.collegeSearchInput.social.collgeSportsClassIds.filter(e1 => e1.sportsClassId === e.id && e1.III).length > 0;
            e.IV = this.collegeSearchInput.social.collgeSportsClassIds.filter(e1 => e1.sportsClassId === e.id && e1.IV).length > 0;
          }
        });

        this.labelsHead.housingOptions.data.map((e) => {

          if (e) {
            switch (e.text) {
              case 'Coed':
                e.checked = this.collegeSearchInput.social.housingCoed;
                break;
              case 'Men Only':
                e.checked = this.collegeSearchInput.social.housingMen;
                break;
              case 'Special Housing for Individuals':
                e.checked = this.collegeSearchInput.social.housingDisabled;
                break;
              case 'Women Only':
                e.checked = this.collegeSearchInput.social.housingWomen;
                break;
              default:
                // code...
                break;
            }
          }
        });

        this.labelsHead.rotc.data.map((e) => {
          if (e) {
            switch (e.text) {
              case 'Air Force':
                e.checked = this.collegeSearchInput.social.airROTC;
                break;
              case 'Army':
                e.checked = this.collegeSearchInput.social.armyROTC;
                break;
              case 'Navy':
                e.checked = this.collegeSearchInput.social.navyROTC;
                break;
              case 'General':
                e.checked = this.collegeSearchInput.social.generalROTC;
                break;
              default:
                // code...
                break;
            }
          }

        });
        this.searchCollege();
      },
      () => {
        this.loading = false;
        this.notificationService.show('error', 'Error While Fetching get DropDown Data')
      });
  }

  viewCollege(id) {
    this._collegeDetailService.setCurrentCollegeById(id);
    this.removeScrollListener();
    this._router.navigate(['../collegeDetail'], { relativeTo: this._routes });
    const localStorageData = this._commonAuthenticationService.getLoginData();

    if (localStorageData.role === 'Student') {
      localStorage.setItem('navigation', '/student/' + this._routes.snapshot.url[0].path);
    }

    if (localStorageData.role === 'Coach' || localStorageData.role === 'Super Coach') {
      localStorage.setItem('navigation', '/coach/' + this._routes.snapshot.url[0].path);
    }
  }


  apiCall(url, data: object, successCallback: Function, error: string, errorFunction?: Function) {
    const json = Object.assign(data, this.partnerUserNToken) as any;
    this._commonRequestResponseService.postWithHeader(url, json)
      .subscribe(
        (dataOutput) => {
          successCallback(dataOutput)
        },
        (errorOutput) => {
          if (errorFunction) {
            errorFunction(errorOutput);
          }
          this.notificationService.show('error', errorOutput || 'Error While calling api');
        });
  }

  setKey(object, key, value?) {
    object[key] = value;
    if (key === 'percentNeedsMet') {
      if (object.noPreferenceNeedsMet) {
        this.collegeSearchInput.supportFinancial.percentNeedsMet = -1
      } else {
        this.collegeSearchInput.supportFinancial.percentNeedsMet = '';
      }
    } else {
      if (object.noPreferenceTuition) {
        this.collegeSearchInput.supportFinancial.tuitionFees = -1;
      } else {
        this.collegeSearchInput.supportFinancial.tuitionFees = '';
      }
    }



  }

  myListFormatter(data: any): string {
    return data.text;
  }


  myValueFormatter(data: any): string {
    return data.text;
  }

  getPageData() {
    this.currentPageId = this._menuService.getCurrentPageId();
  }

  filterData() {
    this.labelsData = [];
    Object.keys(this.labelsHead).forEach((e) => {
      if (this.labelsHead[e].label === 'Sports') {
        this.labelSports = this.labelsHead[e].label;
        this.searchSports = this.labelsHead[e].data;
        this.checkSportsFilter(undefined);
      }

      for (let i = 0; i < this.labelsHead[e].data.length; i++) {

        if (this.labelsHead[e].data[i].checked) {
          this.labelsData.push({ 'label': this.labelsHead[e].label, 'text': this.labelsHead[e].data[i].text })
        }

      }

    })
  }

  checkSportsFilter(item) {
    if (item) {
      const index = this.labelsHead.sports.data.indexOf(item);
      this.labelsHead.sports.data[index].I = false;
      this.labelsHead.sports.data[index].II = false;
      this.labelsHead.sports.data[index].III = false;
      this.labelsHead.sports.data[index].IV = false;
      this.labelsHead.sports.data[index].gender = undefined;

    }
    for (const ob of this.labelsHead.sports.data) {
      if (ob.I || ob.II || ob.III || ob.IV || ob.gender) {
        this.searchSportsFilter = true;
        return;
      }
    }
    this.searchSportsFilter = false;
  }


  showFilter() {
    this.filterShow = true;
  }

  closeData(item, index) {
    this.labelsData.splice(index, 1);
    Object.keys(this.labelsHead).forEach((e) => {
      const data = this.labelsHead[e].data;

      if (data instanceof Array) {
        data.forEach((e1) => {
          if (e1.text === item) {
            e1.checked = false;
            e1.disabled = false;
          }
        });
      }

      const sportData = this.labelsHead.sports.data;

      if (sportData instanceof Array) {
        sportData.forEach((e1) => {
          if (e1.text === item) {
            if (e1.I) {
              e1.I = false;
            } else if (e1.II) {
              e1.II = false;
            } else if (e1.III) {
              e1.III = false;
            } else if (e1.IV) {
              e1.IV = false;
            }
          }

        });
      }
    });
  }

  collegeSearchJsonData() {
    if (!JSON.parse(localStorage.getItem('searchResult'))) {
      return;
    }
    this.collegeSearchInput = JSON.parse(localStorage.getItem('searchResult')) as CollegeSearchInput;
    this.inputToCriteria('degree', this.collegeSearchInput.college, 'degreeTypeClassIds');
    this.inputToCriteria('location', this.collegeSearchInput.college, 'regionClassIds');
    this.inputToCriteria('studentPopulation', this.collegeSearchInput.college, 'schoolPopulationClassIds');
    this.inputToCriteria('state', this.collegeSearchInput.college, 'regionStateClassIds');
    this.inputToCriteria('schoolType', this.collegeSearchInput.college, 'schoolTypeClassIds');
    this.inputToCriteria('classSize', this.collegeSearchInput.college, 'classSizeClassIds');
    this.inputToCriteria('citySize', this.collegeSearchInput.college, 'citySizeClassIds');
    this.inputToCriteria('difficulty', this.collegeSearchInput.academics, 'difficultyClassIds');
    this.inputToCriteria('supportServices', this.collegeSearchInput.supportFinancial, 'supportFinancialClassIds');
    this.inputToCriteria('clubSports', this.collegeSearchInput.social, 'clubSportsClassIds');
    this.inputToCriteria('collegeType', this.collegeSearchInput.college, 'collegeTypeClassIds');
    this.inputToCriteria('careerCluster', this.collegeSearchInput.majorsCareers, 'industry');
    this.inputToCriteria('religious', this.collegeSearchInput.social, 'religious');

    this.collegeSearchInput.majorsCareers.careers.forEach((career: any) => {
      this.selectedCareer.push(this.labelsHead.career.data.find(item => item.id === career))
    });
    this.collegeSearchInput.majorsCareers.majorCode.forEach((majorCode: any) => {
      this.selectedMajor.push(this.labelsHead.majors.data.find(item => item.id === majorCode))
    });
    this.collegeSearchInput.social.religious.forEach((religious: any) => {
      this.selectedReligious.push(this.labelsHead.religious.data.find(item => item.id === religious))
    });

    Object.keys(this.labelsHead).forEach((e) => {
      const ob = this.labelsHead[e];
      ob.data.forEach((e1) => {
        if (e1.checked && e1.text === 'No Preference') {
          ob.data.forEach((e2) => {
            if (!e2.checked) {
              e2.disabled = true;
            }
          });
        }
      });

      this.filterData();
    });

    this.labelsHead.sports.data.forEach((e) => {
      if (e) {
        e.I = this.collegeSearchInput.social.collgeSportsClassIds.filter(e1 => e1.sportsClassId === e.id && e1.I).length > 0;
        e.II = this.collegeSearchInput.social.collgeSportsClassIds.filter(e1 => e1.sportsClassId === e.id && e1.II).length > 0;
        e.III = this.collegeSearchInput.social.collgeSportsClassIds.filter(e1 => e1.sportsClassId === e.id && e1.III).length > 0;
        e.IV = this.collegeSearchInput.social.collgeSportsClassIds.filter(e1 => e1.sportsClassId === e.id && e1.IV).length > 0;
      }
    });

    this.labelsHead.housingOptions.data.map((e) => {

      if (e) {
        switch (e.text) {
          case 'Coed':
            e.checked = this.collegeSearchInput.social.housingCoed;
            break;
          case 'Men Only':
            e.checked = this.collegeSearchInput.social.housingMen;
            break;
          case 'Special Housing for Individuals':
            e.checked = this.collegeSearchInput.social.housingDisabled;
            break;
          case 'Women Only':
            e.checked = this.collegeSearchInput.social.housingWomen;
            break;
          default:
            // code...
            break;
        }
      }
    });

    this.labelsHead.rotc.data.map((e) => {
      if (e) {
        switch (e.text) {
          case 'Air Force':
            e.checked = this.collegeSearchInput.social.airROTC;
            break;
          case 'Army':
            e.checked = this.collegeSearchInput.social.armyROTC;
            break;
          case 'Navy':
            e.checked = this.collegeSearchInput.social.navyROTC;
            break;
          case 'General':
            e.checked = this.collegeSearchInput.social.generalROTC;
            break;
          default:
            // code...
            break;
        }
      }
    });
    this.searchFlag = false;
    this.searchCollege(true);
  }

  ngOnDestroy() {
    this.removeScrollListener();
    this.subs.forEach(sub => sub.unsubscribe());
    localStorage.removeItem('collegeSearchLastPage');
  }
}
